const initialState = {
	username: '',
	email: '',
	userId: '',
	privacyLink: '',
	privacyText: '',
	showPrivacyText: true,
	agreement: false,
	errorMessage: '',
	show: false,
	requireEmailLogin: true,
	requireUsernameLogin: true,
	showMobileChat: false,
};

const chatLoginReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_USERNAME':
			return {
				...state,
				username: action.username,
			};
		case 'SET_EMAIL':
			return {
				...state,
				email: action.email,
			};
		case 'SET_USER_ID':
			return {
				...state,
				userId: action.userId,
			};
		case 'SET_PRIVACY_LINK':
			return {
				...state,
				privacyLink: action.privacyLink,
			};
		case 'SET_PRIVACY_TEXT':
			return {
				...state,
				privacyText: action.username,
			};
		case 'SET_SHOW_PRIVACY_TEXT':
			return {
				...state,
				showPrivacyText: action.showPrivacyText,
			};
		case 'SET_AGREEMENT':
			return {
				...state,
				agreement: action.agreement,
			};
		case 'SET_ERROR_MESSAGE':
			return {
				...state,
				errorMessage: action.errorMessage,
			};
		case 'SET_SHOW_LOGIN_FORM':
			return {
				...state,
				show: action.show,
			};
		case 'SET_REQUIRE_EMAIL_LOGIN':
			return {
				...state,
				requireEmailLogin: action.requireEmailLogin,
			};
		case 'SET_REQUIRE_USERNAME_LOGIN':
			return {
				...state,
				requireUsernameLogin: action.requireUsernameLogin,
			};
		case 'SET_SHOW_MOBILE_CHAT':
			return {
				...state,
				showMobileChat: action.showMobileChat,
			};
		default:
			return state;
	}
};

export default chatLoginReducer;
